// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2Sxtw","large":"styles_large__3bNmA"};